import { Component } from '@angular/core';
import { EdiModalChangeLineComponent } from 'gung-standard';

@Component({
  selector: 'otto-olsen-edi-modal-change-line',
  templateUrl: './otto-olsen-edi-modal-change-line.component.html',
  styleUrl: './otto-olsen-edi-modal-change-line.component.scss',
  standalone: false
})
export class OttoOlsenEdiModalChangeLineComponent extends EdiModalChangeLineComponent {
  validate: boolean = true;
}
